import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  processingBatchTitle: {
    description: 'title for processing quickship batch',
    defaultMessage: 'Processing Your Batch',
    id: 'Qfx4hF',
  },
  processingBatchContent: {
    description: 'content for processing quickship batch',
    defaultMessage: "We're processing your batch now.",
    id: 'uBrxdi',
  },
  purchasingBatchTitle: {
    description: 'title for processing quickship batch',
    defaultMessage: 'Purchasing Your Labels',
    id: 'Cpw72P',
  },
  purchasingBatchContent: {
    description: 'content for processing quickship batch',
    defaultMessage: "We're purchasing the labels for your batch now.",
    id: 'yaMwH5',
  },
  purchasingHadOnlyErrorsTitle: {
    description: 'title for processing quickship batch only errors',
    defaultMessage: 'Purchasing Labels Failed',
    id: 'mUl4Pa',
  },
  purchasingHadOnlyErrorsContent: {
    description: 'content for processing quickship batch only errors',
    defaultMessage: 'Purchasing labels for your batch failed. Please check your Label Queue for more details.',
    id: 'Q2rcut',
  },
  purchasingHadSomeErrorsTitle: {
    description: 'title for processing quickship batch some errors',
    defaultMessage: 'Purchasing Your Labels Partially Succeeded',
    id: 'iBKUBq',
  },
  purchasingHadSomeErrorsContent: {
    description: 'content for processing quickship batch some errors',
    defaultMessage:
      'We encountered some errors while purchasing your labels. {successCount, plural, one {# label} other {# labels}} succeeded and {errorCount, plural, one {# label} other {# labels}} had errors. Please check your Label Queue for more details.',
    id: 'z1WV+u',
  },
  purchasingBatchesSuccessTitle: {
    description: 'title for processing quickship batch only success',
    defaultMessage: 'Purchasing Labels Success',
    id: 'IjE/DF',
  },
  purchasingBatchesSuccessContent: {
    description: 'content for processing quickship batch only success',
    defaultMessage: 'Purchasing labels for your batch was successful!',
    id: '1SXGDB',
  },
  purchasingBatchesSuccessWithWarningsContent: {
    description: 'content for processing quickship batch only success with warnings',
    defaultMessage:
      'Purchasing labels for your batch was successful, but {warningsCount, plural, one {# label} other {# labels}} had warnings. Please check your Label Queue for more details.',
    id: 'aIrXTD',
  },
  purchasingBatchLowShipsuranceBalance: {
    description: 'content for when batches purchasing circumvents cost review but has low shipsurance balance',
    defaultMessage:
      'Please ensure your Shipsurance balance has enough funds to purchase insurance for all selected shipments and try again.',
    id: 'BFfUmU',
  },
  apiError: {
    description: 'content for generic api request failure',
    defaultMessage: 'An unexpected error occurred. Please try again.',
    id: 'MhRYHJ',
  },
});
